import { Box, Button, Paper, Stack } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { AuthContext } from "~/auth/AuthProvider";
import { SubtitleText } from "~/components/Typographies";

const BenchmarkUnavailable = () => {
	const { t } = useTranslation("common");
	const { redirectToLogout } = useContext(AuthContext);

	return (
		<Box sx={{ display: "flex", justifyContent: "center", px: 2, py: 6 }}>
			<Paper sx={{ maxWidth: 480, p: 4, width: "100%" }} variant="outlined">
				<Stack spacing={2}>
					<SubtitleText align="center">{t("errorPages.benchmarkUnavailable.message")}</SubtitleText>
					<Button onClick={() => redirectToLogout()} variant="contained">
						{t("errorPages.benchmarkUnavailable.signOut")}
					</Button>
				</Stack>
			</Paper>
		</Box>
	);
};

export default BenchmarkUnavailable;
